export default __webpack_public_path__ + "static/media/odob_axloq_kodeksi.4fc58b64.pdf";